import formatToCurrency from '../scripts/_modules/currency/format_to_currency';

const noop = () => {};

const identity = (x) => x;

const cloneDeep = (data) => JSON.parse(JSON.stringify(data));

const isEqual = (x, y) => JSON.stringify(x) === JSON.stringify(y);

const size = (obj) => Object.keys(obj).length;

const pick = (object, keys) => {
  return keys.reduce((obj, key) => {
    if (object && Object.prototype.hasOwnProperty.call(object, key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
};

const sortBy = (key) => {
  return (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
};

const pickBy = (obj, fn) =>
  obj &&
  Object.keys(obj)
    .filter((k) => fn(obj[k], k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {});

const throttle = (fn, wait) => {
  let inThrottle, lastFn, lastTime;
  return function () {
    const context = this,
      args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(
        function () {
          if (Date.now() - lastTime >= wait) {
            fn.apply(context, args);
            lastTime = Date.now();
          }
        },
        Math.max(wait - (Date.now() - lastTime), 0),
      );
    }
  };
};

const forOwn = (obj, fn) => obj && Object.keys(obj).forEach((key) => fn(obj[key], key, obj));

const isEmpty = (obj) => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;

const range = (length) => Array.from({ length }, (_, i) => i);

const findKey = (obj, fn) => Object.keys(obj).find((key) => fn(obj[key], key, obj));

const map = (array, iteratee) => {
  let index = -1;
  const length = array == null ? 0 : array.length;
  const result = new Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
};

const getURLParameters = (url) =>
  (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
    {},
  );

const upperFirst = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

const flow = (...funcs) => {
  const length = funcs.length;
  let index = length;
  while (index--) {
    if (typeof funcs[index] !== 'function') {
      throw new TypeError('Expected a function');
    }
  }
  return function (...args) {
    let index = 0;
    let result = length ? funcs[index].apply(this, args) : args[0];
    while (++index < length) {
      result = funcs[index].call(this, result);
    }
    return result;
  };
};

const mapValues = (obj, fn) =>
  obj &&
  Object.keys(obj).reduce((acc, k) => {
    acc[k] = fn(obj[k], k, obj);
    return acc;
  }, {});

const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));

const forEachOnObject = (obj, fn) => {
  Object.keys(obj).forEach((x) => fn(obj[x]));
};

const replace = (a, b, c) => {
  const string = c.toString();
  return !c ? string : string.replace(a, b);
};

const reverse = (array) => {
  if (array && typeof array === 'string') {
    array = array.split('');
  }
  return array ? array.reverse() : array;
};

const isMatch = (a, b) => {
  const obj1 = a;
  const obj2 = b;
  const obj1Keys = Object.keys(obj1).sort();
  const obj2Keys = Object.keys(obj2).sort();

  return obj1Keys.every((key, index) => {
    const objValue1 = obj1[key];
    const objValue2 = obj2[obj2Keys[index]];
    return objValue1 === objValue2;
  });
};

const set = (obj, path, value) => {
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);

  pathArray.reduce((acc, key, i) => {
    if (acc[key] === undefined) acc[key] = {};
    if (i === pathArray.length - 1) acc[key] = value;
    return acc[key];
  }, obj);
};

const setPaypalTotalPrice = (totalPrice) => {
  const paypalPaymentValue = document.querySelectorAll('.paypal-payment-value');

  paypalPaymentValue.forEach((ppv) => {
    const ppvPrice = totalPrice / 4;
    ppv.innerHTML = formatToCurrency(ppvPrice, TYROOLA.globals.currencyIsoCode, false, true, {});
  });
};

const preparePaypalTotalPrice = (totalPrice) => {
  let total = 0;

  if (totalPrice) {
    total = totalPrice.substring(1).trim();
    if (TYROOLA.globals.store === 'DE') {
      total = total.replaceAll(',', '?');
      total = total.replaceAll('.', ',');
      total = total.replaceAll('?', '.');
    }
    total = total.replaceAll(',', '');
    setPaypalTotalPrice(total * 100);
  }
};

const isContainerLoadedInDOM = (container) => {
  if (!TYROOLA.root) {
    TYROOLA.root = {};
  }
  return container ? Object.keys(container).filter((p) => p.indexOf('__react') !== -1).length : 0;
};

const getColor = (value) => {
  let color = '';
  if (value === 'mainColor') {
    color = TYROOLA.globals.store === 'DE' ? '#00ab04' : '#fac200';
  } else if (value === 'mainColorDark') {
    color = TYROOLA.globals.store === 'DE' ? '#008503' : '#FBC300';
  }
  return color;
};

function triggerInstantJSAddToCartEvent(id, qty) {
  try {
    let products = TYROOLA.initialFluxStates.topCartProducts ? [...TYROOLA.initialFluxStates.topCartProducts] : [];

    if (!products.find((p) => p.id === id)) {
      let addedProduct = TYROOLA.initialFluxStates.product ? TYROOLA.initialFluxStates.product : null;

      if (!addedProduct) {
        addedProduct = TYROOLA.initialFluxStates.products
          ? TYROOLA.initialFluxStates.products.find((p) => p.sku === id)
          : null;
      }

      if (!addedProduct) {
        addedProduct = TYROOLA.initialFluxStates.promotions
          ? TYROOLA.initialFluxStates.promotions.find((p) => p.sku === id)
          : null;
      }
      if (addedProduct) {
        addedProduct = {
          ...addedProduct,
          id: addedProduct.sku || addedProduct.id || addedProduct.spinach,
          quantity: addedProduct.qty || (addedProduct.stock >= 4 ? 4 : addedProduct.stock),
          productUrl: addedProduct.url ? `${TYROOLA.globals.storeUrl}${addedProduct.url}` : window.location.href,
        };
        products.push(addedProduct);
      }
    }

    const event = {
      Store: `${TYROOLA.globals.store}`,
      CheckoutURL: `${TYROOLA.globals.baseHref}/cart/`,
      Items: products.map((product) => ({
        ProductID: product.id,
        SKU: product.id,
        ProductName: `${product.manufacturer} ${product.model} ${product.dimensions}`,
        Quantity: product.id === id ? product.quantity + qty : product.quantity,
        ItemPrice: product.priceRaw ? product.priceRaw / 100 : product.price / 100,
        ProductURL:
          product.productUrl || (product.url ? `${TYROOLA.globals.storeUrl}${product.url}` : window.location.href),
        ImageURL: product.tyreImage || product.productImage,
        ProductCategories: [product.productType || product.type || 'tyre'],
      })),
    };

    event.Items = event.Items.map((i) => ({ ...i, RowTotal: i.Quantity * i.ItemPrice }));

    triggerKlaviyoAddToCartEvent(event, id);
    window.InstantJS.track('ITEM_ADDED_TO_CART', [
      {
        provider: 'KLAVIYO',
        event,
      },
    ]).then(() => {
      console.log('ITEM_ADDED_TO_CART completed');
    });
  } catch (e) {
    console.log(e.message);
  }
}

function triggerKlaviyoAddToCartEvent(event, id) {
  let totalToPay = 0;
  event.Items.forEach((i) => {
    totalToPay += i.RowTotal;
  });

  const klaviyoEvent = {
    ...event,
    $value: totalToPay,
    AddedItemProductName: event.Items.find((p) => p.SKU === id).ProductName,
    AddedItemProductID: event.Items.find((p) => p.SKU === id).SKU,
    AddedItemSKU: event.Items.find((p) => p.SKU === id).SKU,
    AddedItemCategories: event.Items.find((p) => p.SKU === id).ProductCategories,
    AddedItemImageURL: event.Items.find((p) => p.SKU === id).ImageURL,
    AddedItemURL: event.Items.find((p) => p.SKU === id).ProductURL,
    AddedItemPrice: event.Items.find((p) => p.SKU === id).ItemPrice,
    AddedItemQuantity: event.Items.find((p) => p.SKU === id).Quantity,
    ItemNames: event.Items.map((i) => i.ProductName),
  };

  klaviyo.track('Added to Cart', klaviyoEvent).then(() => console.log('Added to Cart completed'));
}

function isReCaptchaActionAllowed(actionNameWithoutStore) {
  const { recaptcha } = TYROOLA.globals.google;
  return (
    window.grecaptcha &&
    recaptcha &&
    recaptcha.enabled &&
    recaptcha.enabledActions &&
    recaptcha.enabledActions.some((item) => item.includes(`${actionNameWithoutStore}${TYROOLA.globals.store}`))
  );
}

export {
  chunk,
  cloneDeep,
  findKey,
  flow,
  forEachOnObject,
  forOwn,
  getURLParameters,
  identity,
  isEmpty,
  isEqual,
  map,
  mapValues,
  noop,
  pick,
  pickBy,
  range,
  size,
  sortBy,
  throttle,
  upperFirst,
  replace,
  reverse,
  isMatch,
  set,
  setPaypalTotalPrice,
  preparePaypalTotalPrice,
  isContainerLoadedInDOM,
  getColor,
  triggerInstantJSAddToCartEvent,
  isReCaptchaActionAllowed,
};
